var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftSLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-left-s-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.0473 20.0012L26.297 28.2507L23.94 30.6077L13.3333 20.0012L23.94 9.39453L26.297 11.7515L18.0473 20.0012Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftSLine);
export default __webpack_public_path__ + "static/media/arrow-left-s-line.8e8c9feafd989d0a9932217ea9e6d2a7.svg";
export { ForwardRef as ReactComponent };